import { render, staticRenderFns } from "./Fepanacom.vue?vue&type=template&id=84ff7484&"
import script from "./Fepanacom.vue?vue&type=script&lang=js&"
export * from "./Fepanacom.vue?vue&type=script&lang=js&"
import style0 from "./Fepanacom.vue?vue&type=style&index=0&id=84ff7484&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports